var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCambiarEntitat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9304_3254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11.9997V7.33301",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74641 1.46507C6.92934 1.37621 7.13017 1.33037 7.33354 1.33106C7.53691 1.33176 7.73742 1.37896 7.91974 1.46907L13.1637 4.03373C13.4811 4.18907 13.3704 4.6664 13.0171 4.6664H1.64908C1.29574 4.6664 1.18574 4.18907 1.50241 4.03373L6.74641 1.46507Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 14.667H7.33333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 11.9997V7.33301",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.66699V9.33366H10.6667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33302L9.02333 8.26302C9.40603 7.89522 9.87102 7.62413 10.3796 7.47229C10.8882 7.32046 11.4257 7.29228 11.9474 7.3901C12.4691 7.48792 12.9599 7.7089 13.379 8.03467C13.798 8.36044 14.1332 8.78157 14.3567 9.26302",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 14.6667V12H12",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6662 12L13.6429 13.07C13.2602 13.4378 12.7952 13.7089 12.2866 13.8607C11.778 14.0126 11.2405 14.0407 10.7188 13.9429C10.1971 13.8451 9.70633 13.6241 9.28728 13.2983C8.86823 12.9726 8.53303 12.5515 8.30957 12.07",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9304_3254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCambiarEntitat);
export default __webpack_public_path__ + "static/media/cambiar_entitat.a33f524a32409f1393c3737d3e4424b4.svg";
export { ForwardRef as ReactComponent };